import useApiClient from "../../useApiClient";
import { useSelector } from "react-redux";
import { useCallback } from "react";
import { withNetworkErrorHandling } from "../../helpers/withNetworkErrorHandling";

const useMessagesAPIClient = () => {
  const { set, get } = useApiClient();
  const { activeUser } = useSelector((state) => state.user);

  const getMessages = useCallback(async () => {
    return await withNetworkErrorHandling(() =>
      get(`users/${activeUser.userId}/messages`),
    );
  }, [activeUser, get]);

  const markMessageAsRead = useCallback(
    async (messageId) => {
      return await withNetworkErrorHandling(() =>
        set(`users/${activeUser.userId}/messages`, { messageId }),
      );
    },
    [activeUser, set],
  );

  const sendReply = useCallback(
    async (message, originalMessageId) => {
      return await withNetworkErrorHandling(() =>
        set(`users/${activeUser.userId}/messages`, {
          action: "reply",
          message,
          originalMessageId,
        }),
      );
    },
    [activeUser, set],
  );

  const submitDeletionRequest = useCallback(
    async ({ displayName, email }) => {
      return await withNetworkErrorHandling(() =>
        set(`users/${activeUser.userId}/messages`, {
          action: "deletion-request",
          displayName,
          email,
        }),
      );
    },
    [activeUser, set],
  );

  return {
    getMessages,
    markMessageAsRead,
    sendReply,
    submitDeletionRequest,
  };
};

export default useMessagesAPIClient;
